import { jsx as _jsx } from "react/jsx-runtime";
import { useParams } from 'react-router-dom';
import { ContentForm } from '../../form';
import { useFillFormForUpdate } from 'src/modules/contents/hooks/useFillFormForUpdate';
import { LoadError } from 'src/shared/components/loadError';
import { ContentFormLoader } from './loader';
export const Body = ({ isRedirectingToNewContentForm }) => {
    const { pageId } = useParams();
    const { isFormLoading, isError, refetch } = useFillFormForUpdate({
        pageId
    });
    if (isFormLoading || isRedirectingToNewContentForm) {
        return _jsx(ContentFormLoader, { isRedirectingToNewContentForm: isRedirectingToNewContentForm });
    }
    if (isError) {
        return _jsx(LoadError, { onTryAgain: refetch });
    }
    return _jsx(ContentForm, {});
};
